<script setup>
const props = defineProps({
  groups: {
    type: Array,
    default: () => [],
    // [{ title: string, columns?: number, items: [{ label: string, value: string }] }]
  },
  columns: {
    type: Number,
    default: 1,
    validator: (v) => [1, 2].includes(v),
  },
});

function getColumns(group) {
  return group.columns || props.columns;
}
</script>

<template>
  <div class="flex flex-col gap-4">
    <div v-for="(group, gi) in groups" :key="gi" class="flex flex-col gap-2">
      <p v-if="group.title" class="text-sm font-semibold text-foreground">
        {{ group.title }}
      </p>
      <div
        class="grid gap-x-6 gap-y-2"
        :class="getColumns(group) === 2 ? 'grid-cols-2' : 'grid-cols-1'"
      >
        <div
          v-for="(item, ii) in group.items"
          :key="ii"
          class="flex flex-col gap-0.5"
        >
          <span class="text-xs text-muted-foreground">{{ item.label }}</span>
          <span class="text-xs text-foreground">
            {{ item.value || "—" }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
